import { Component, OnInit, inject, input } from '@angular/core';
import { IsActiveMatchOptions, Router, RouterModule, RouterOutlet } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { EnvironmentVariablesService } from 'src/app/services/environment-variables.service';
import { CommonModule } from '@angular/common';
import { InvestorDropdownComponent } from '../investor-dropdown/investor-dropdown.component';
import { GcmSidenavComponent, NavItem } from '@gcm/gcm-ui-angular';
import { MatSidenavModule } from '@angular/material/sidenav';

@Component({
    selector: 'app-sidenav',
    imports: [CommonModule, InvestorDropdownComponent, GcmSidenavComponent, MatSidenavModule, RouterOutlet, RouterModule],
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {
  router = inject(Router);
  private userService = inject(UserService);
  evService = inject(EnvironmentVariablesService);

  readonly showMobileSideNav = input<boolean>(false);
  currentPage: string | undefined;
  navigationItems: NavItem[] = [];
  displayName = '';
  opened = false;
  routerLinkActiveOptions: IsActiveMatchOptions = { paths: 'subset', matrixParams: 'ignored', queryParams: 'ignored', fragment: 'ignored' };

  ngOnInit(): void {
    this.loadNavigationItems();
    this.displayName = this.userService.getUserFullName();
  }

  loadNavigationItems(): void {
    this.navigationItems = [];
    this.addToNavigation('Dashboard', 'investor', 'dashboard', false);
    this.addToNavigation('Contact', 'contact', 'contacts_product', false);
    if (this.userService.isAdmin() && !this.userService.isExternalUser() && !this.evService.productionURL.includes('demo')) {
      this.addToNavigation('Document Review', 'document-review', 'assignment', false);
    }
    if (this.userService.getApplicationAccess().indexOf('clientdocs') > -1) {
      // check if user has access to client docs, if yes then show client docs as docs in nav
      this.addToNavigation('Documents', this.evService.clientDocs, 'description', true);
    } else if (this.userService.getApplicationAccess().indexOf('vistaone') > -1) {
      // check if user has access to vista one, if yes then show vista one as docs in nav
      this.addToNavigation('Documents - VistaOne', this.evService.externalUris['vistaOne'], 'description', true)
    }
    if (this.userService.getApplicationAccess().indexOf('arsportal') > -1) {
      this.addToNavigation('ARS', this.evService.arsUri, null, true, 'https://images.ctfassets.net/hhmmh7cybzrp/6JgmwZg5uNO1jzR1oxDwce/329d5202d975f805072e5c5c276acfb6/fundsARS_B.png')
    }
    if (this.userService.doesUserHaveSEIAccess()) {
      this.addToNavigation('Documents - SEI', this.evService.externalUris['sei'], 'description', true)
    }
  }

  addToNavigation(name: string, url: string, icon: string | null, isExternalUrl: boolean, iconImg?: string) {
    this.navigationItems.push({
      label: name,
      name,
      url,
      externalUrl: isExternalUrl,
      icon: icon as string,
      iconImg
    });
  }
}
